import { IVendorPincodeInitialState } from "../../../types/master/vendorPincodeInterface";
import { VendorPincodeActionTypes, VendorPincodeActions } from "../../actionTypes/master/vendorPincodeActionTypes";

const initialState: IVendorPincodeInitialState = {
  vendorPincodeList: [],
  vendorPincodeListPageCount: 0,
};

export default function vendorPincodeReducer(
  state = initialState,
  action: VendorPincodeActionTypes
): IVendorPincodeInitialState {
  switch (action.type) {
    case VendorPincodeActions.SET_VENDOR_PINCODE_LIST:
      return {
        ...state,
        vendorPincodeList: action.payload,
      };

    case VendorPincodeActions.SET_VENDOR_PINCODE_LIST_PAGE_COUNT:
      return {
        ...state,
        vendorPincodeListPageCount: action.payload,
      };

    default:
      return state;
  }
}
